<template>
  <div class="wrapper">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { homeOnShowReporting } from "@/utils/reporting";

onMounted(async () => {
  homeOnShowReporting();
});
</script>

<style scoped></style>
